import React from 'react';
import { FadeIn } from './FadeIn';
const levels = [{
  badge: 'Nivel 1:',
  title: 'Preparación Lectora y Trazos',
  description: 'Actividades para desarrollar motricidad fina y reconocimiento de patrones. La base para preparar el cerebro antes de leer.',
  image: 'https://cdn.magicpatterns.com/uploads/k1Rga1X5RKmCciKSzzoYMU/task_01kcyjgtj6eebsg7cdwn1c3ava_1766257664_img_0_(1).webp'
}, {
  badge: 'Nivel 2:',
  title: 'Asociación Sonido-Letra (Sílabas)',
  description: '¿Tu hijo reconoce sonidos? Actividades para asociar cada sonido con su letra correspondiente de forma natural.',
  image: 'https://cdn.magicpatterns.com/uploads/7pmZwkQKKbygPtKLu2Tzy7/task_01kcyk7602fzhvegrb2whx4gen_1766258398_img_0.webp'
}, {
  badge: 'Nivel 3:',
  title: 'Construcción de Palabras',
  description: 'De sílabas a palabras completas. Ejercicios progresivos para formar palabras y empezar a leer con fluidez.',
  image: 'https://cdn.magicpatterns.com/uploads/c7qQvfo2Apqo42wJ3pfcHi/task_01kcymn64rf1k8a56gffffh3y5_1766259900_img_1.webp'
}, {
  badge: 'Guía:',
  title: 'Guía Paso a Paso para Padres',
  description: 'Instrucciones claras para acompañar a tu hijo en cada etapa, incluso si no tenés experiencia docente.',
  image: 'https://cdn.magicpatterns.com/uploads/gLech26jSjnSY8cFKr6mr4/task_01kcyn2xw1fzxajbthjdvh1f7d_1766260353_img_0.webp'
}];
export function WhatIsIncluded() {
  return <section className="py-8 md:py-20 px-4 bg-white relative overflow-hidden" data-id="element-448">
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-449">
        <FadeIn data-id="element-450">
          <div className="text-center mb-8 md:mb-16" data-id="element-451">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 leading-tight mb-4 md:mb-6" data-id="element-452">
              <span className="mr-2" data-id="element-453">📚</span> ¿Qué incluye tu pasaporte a la
              lectura sin frustración?
            </h2>
            <div className="w-24 h-1 bg-accent-gold mx-auto rounded-full" data-id="element-454"></div>
          </div>
        </FadeIn>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-6" data-id="element-455">
          {levels.map((level, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-456">
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden h-full flex flex-col hover:shadow-md transition-shadow duration-300" data-id="element-457">
                {/* Product image */}
                <div className="aspect-[3/2] overflow-hidden border-b border-gray-100" data-id="element-458">
                  <img src={level.image} alt={level.title} className="w-full h-full object-cover" data-id="element-459" />
                </div>

                {/* Content */}
                <div className="p-3 md:p-6 flex flex-col flex-1 text-left" data-id="element-460">
                  {/* Badge */}
                  <div className="mb-2 md:mb-4" data-id="element-461">
                    <span className="bg-accent-gold text-white text-[10px] md:text-xs font-bold uppercase tracking-wider px-2 py-0.5 md:px-2.5 md:py-1 rounded-md" data-id="element-462">
                      {level.badge}
                    </span>
                  </div>

                  {/* Title */}
                  <h3 className="text-sm md:text-lg font-semibold text-gray-900 mb-1.5 md:mb-2 leading-snug" data-id="element-463">
                    {level.title}
                  </h3>

                  {/* Description */}
                  <p className="text-gray-500 text-xs md:text-sm leading-relaxed flex-1" data-id="element-464">
                    {level.description}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}